export default __webpack_public_path__ + "static/media/pig-project.16414ed2.svg";